import { matchPath } from 'react-router'
import useNavigation from 'core/hooks/navigation/useNavigation'

const useUrlTeamId = (): string => {
  const { pathname } = useNavigation()
  const m = matchPath('/team/:token_id/*', pathname)
  return m?.params?.token_id ?? ''
}

export default useUrlTeamId
